export const FrequencyType = {
  weekly: "weekly",
  biweekly: "biweekly",
  monthly: "monthly",
  annual: "annual",
};
